import React, {FC} from 'react'
import MainAsideMenuLayout from "@layouts/mainAsideMenuLayout/MainAsideMenuLayout";


const NotificationsPage: FC<any> = (props) => {

  let {} = props

  return (
    <MainAsideMenuLayout>
      {/*<BackLinkLayout>*/}
      <div>Notifications
      </div>
      {/*</BackLinkLayout>*/}
    </MainAsideMenuLayout>
  )
}

export default NotificationsPage;